import React from 'react';
import {useIntl} from 'react-intl';

import {Button, BUTTON_SIZE, BUTTON_VARIANT} from '@time-webkit/all/atoms/button';
import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';
import {Spinner} from '@time-webkit/all/atoms/spinner';

import classNames from 'classnames';

import styles from './styles.module.css';

type RetryViewProps = {
    retry: () => void;
    loading: boolean;
}

export const RetryView: React.FC<RetryViewProps> = ({retry, loading}) => {
    const {formatMessage} = useIntl();
    const typographyCls = useTypography({size: TypographySize.BodyM, noDefaultColor: true});
    const buttonLabel = formatMessage({id: 'autocomplete.error.button', defaultMessage: 'Try again'});

    return (
        <div className={styles.tryAgainWrapper}>
            <span className={classNames(typographyCls, styles.tryAgainTitle)}>
                {formatMessage({
                    id: 'autocomplete.error.title',
                    defaultMessage: 'Something went wrong, try again later',
                })}
            </span>
            <Button
                className={styles.tryAgainButton}
                variant={BUTTON_VARIANT.TERTIARY}
                size={BUTTON_SIZE.SMALL}
                onPress={retry}
                aria-label={buttonLabel}
                block={true}
            >
                {loading ? <Spinner size={16} /> : buttonLabel}
            </Button>
        </div>
    );
};
